@if (hasNoProducts()) {
  {{ 'products_emptyList' | translate }}
} @else {
  <ion-grid class="ion-margin-horizontal ion-padding-horizontal">
    <ion-row>
      <ion-col>
        <h2>{{ _title() | translate }}</h2>
        <p>{{ _intro() | translate }}</p>
      </ion-col>
    </ion-row>
  </ion-grid>

  @if (selectedProduct()) {
    <ion-grid
      class="summary ion-margin-horizontal ion-padding-horizontal summary"
    >
      <ion-row>
        <ion-col
          ><b>{{ 'basket_buy' | translate }}</b></ion-col
        >
      </ion-row>
      <ion-row class="buy ion-no-margin ion-no-padding">
        <ion-col
          >{{ selectedProductAmount() }}
          {{ selectedProductName() | translate }}</ion-col
        >
        <ion-col class="ion-text-right"
          >&euro; {{ selectedProductPrice() }}
          @if (selectedProductRecurring()) {
            <span>{{ 'products_perYear' | translate }}</span>
          }
        </ion-col>
      </ion-row>
      <ion-row class="ion-margin-vertical">
        <ion-col>
          <ion-icon
            (click)="onBackClicked()"
            name="arrow-back-circle-outline"
          ></ion-icon>
        </ion-col>
        <ion-col class="ion-text-right">
          <ion-button (click)="onBuyClicked()">
            <small>{{ 'basket_buyOnline' | translate }}</small></ion-button
          >
        </ion-col>
      </ion-row>
    </ion-grid>
  } @else {
    <ion-grid class="ion-no-margin ion-no-padding">
      <ion-row class="ion-margin-horizontal ion-margin-bottom ion-no-padding">
        @for (product of _products(); track product.uid) {
          <ion-col size-xs="12" size-sm="12" size-md="6">
            <div class="product ion-margin ion-padding">
              <form [formGroup]="form" (ngSubmit)="onProductClicked(product)">
                <h3>{{ product.name | translate }}</h3>
                <h2>
                  &euro; {{ product.price }}
                  @if (product.recurring) {
                    <span>{{ 'products_perYear' | translate }}</span>
                  }
                </h2>
                <p [innerHTML]="product.info ?? '' | translate"></p>

                <ion-grid>
                  <ion-row>
                    <ion-col class="ion-margin-end">
                      <ion-select
                        ok-text="okay"
                        cancel-text="Dismiss"
                        formControlName="amount"
                      >
                        @for (item of [].constructor(100); track $index) {
                          <ion-select-option [value]="$index + 1">
                            {{ $index + 1 }}
                          </ion-select-option>
                        }
                      </ion-select>
                    </ion-col>
                    <ion-col>
                      <ion-button type="submit">
                        <small>{{ 'products_buy' | translate }}</small>
                      </ion-button>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </form>
            </div>
          </ion-col>
        }
      </ion-row>
    </ion-grid>
  }
}
